import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/rate/style/index.js
// module id = 146
// module chunks = 31